// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".drop-enter-active,.drop-leave-active{-webkit-transition:all .5s ease-out;transition:all .5s ease-out;max-height:400px;max-width:280px}.drop-enter,.drop-leave-to{max-height:0;opacity:0;max-width:0;-webkit-transform:translateY(-200px);transform:translateY(-200px);-webkit-transform:scaleY(0);transform:scaleY(0)}", ""]);
// Exports
module.exports = exports;
